/**
 * Sub1 Template
 * @category testApp
 */
import Utils from '../../common/Utils';

class AbilityrightheaderTempl {
    /**
     * Sub1 Templ
     * @param  {Object} _d={}
     */
    static getRightHeaderTempl(_d={}, _serverType='') {
        return `
        ${_serverType == 'LIVE' ? `<strong class="ability-title">생명력</strong>`:``}
        <a href="" role="button" class="ability-layer-link">
            <span class="ability-point icon-defense-total ${_d.point.maxHp > 0 ? 'is-active':''}"><span class="blind">생명력</span><em class="ability-point-num">${_d.point.defensePoint}p</em></span>
            <span class="ability-point icon-defense-1 ${_d.point.picks[1].point > 0 ? 'is-active':''}"><span class="blind">재생</span><em class="ability-point-num">${_d.point.picks[1].point}p</em></span>
            <span class="ability-point icon-defense-2 ${_d.point.picks[2].point > 0 ? 'is-active':''}"><span class="blind">이동속도</span><em class="ability-point-num">${_d.point.picks[2].point}p</em></span>
            <span class="ability-point icon-defense-3 ${_d.point.picks[4].point > 0 ? 'is-active':''}"><span class="blind">상태이상</span><em class="ability-point-num">${_d.point.picks[4].point}p</em></span>
        </a>
        <div class="ability-header-layer"></div>
    	`;
    }
    static getNEORightHeaderTempl(_d={}, _serverType='') {
        return `
        <strong class="ability-title">생명력</strong>
        <span class="ability-hp-point">
            ${Utils.addThousandSeparatorCommas(_d.hp)}p
        </span>
    	`;
    }

} // end of class

export default AbilityrightheaderTempl;